import { supabase } from "@/integrations/supabase/client";

export type TailoringMode = "fixed_duplicate" | "claude_direct" | "simple";

export const TAILORING_ROUTES: Record<TailoringMode, string> = {
  fixed_duplicate: "/resume-tailoring-fixed-duplicate",
  claude_direct: "/resume-tailoring-claude-direct",
  simple: "/resume-tailoring-simple",
};

export const TAILORING_LABELS: Record<TailoringMode, string> = {
  fixed_duplicate: "Fixed Duplicate",
  claude_direct: "Claude Direct (9-prompt pipeline)",
  simple: "Simple Tailoring",
};

export async function getTailoringMode(): Promise<TailoringMode> {
  const { data, error } = await supabase
    .from("app_settings")
    .select("value")
    .eq("key", "tailoring_mode")
    .single();
  if (error || !data) return "fixed_duplicate";
  const val = data.value as TailoringMode;
  if (val in TAILORING_ROUTES) return val;
  return "fixed_duplicate";
}

export async function setTailoringMode(mode: TailoringMode): Promise<void> {
  await supabase
    .from("app_settings")
    .upsert({ key: "tailoring_mode", value: mode, updated_at: new Date().toISOString() });
}
